<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.evg_sku_label_fa_search') ||
                  '面料编号/名称/成分 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        label-position="left"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fabricStatusList') || '面料状态'"
            >
              <el-checkbox-group v-model="form.fabricStatusList">
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_valid') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('INDEX.form_label_invalid') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fabricColorNo') || '面料编号'"
            >
              <el-input
                v-model.trim="form.fabricColorNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fabricName') || '面料名称'"
            >
              <el-input
                v-model.trim="form.fabricName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fabricNameen') || '面料英文名称'"
            >
              <el-input
                v-model.trim="form.fabricNameEn"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fabricContent') || '面料成分'"
            >
              <el-input
                v-model.trim="form.fabricContent"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.evg_sku_label_fabricContentEn') || '面料英文成分'
              "
            >
              <el-input
                v-model.trim="form.fabricContentEn"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fabricAgentCode') || '业务开发'"
            >
              <dict-select
                clearable
                v-model="form.fabricAgentCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_supCode') || '供应商'"
            >
              <dict-select
                v-model="form.supCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  fabricStatusList: ['Y'],
  listNeedInspection: [],
  listIsVc: [],
  listApplicationStatus: [],
}
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' },
      collectionParams: { dictType: 'skuCollection' },
      categoryTree: [],
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
